import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * Shipment detail -- `/shipments/$shipmentId`.
 *
 * Code-split: the heavy page component (with `DocumentsList` /
 * `LotsList` / `PartiesList` / `HeistsList` / `TrackingTimeline` and
 * their per-domain zod schemas + query keys) lives in
 * `$shipmentId.page.tsx` and is loaded lazily via
 * `lazyRouteComponent`. Visiting `/shipments` no longer pays the
 * detail-page cost.
 *
 * The Route symbol stays in this file so `router.tsx` can register
 * it without dragging the page chunk into the eager bundle.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/shipments/$shipmentId",
	component: lazyRouteComponent(() => import("./$shipmentId.page")),
})
